'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = require('react-redux');

var _reactIntl = require('@liveauctioneers/react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultSelector(state) {
    var intl = state.intl;

    return (0, _extends3.default)({}, intl);
}

var mapStateToProps = function mapStateToProps(state, _ref) {
    var _ref$intlSelector = _ref.intlSelector,
        intlSelector = _ref$intlSelector === undefined ? defaultSelector : _ref$intlSelector;
    return intlSelector(state);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_reactIntl.IntlProvider);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/IntlRedux/IntlProvider.js
// module id = BQBf
// module chunks = 60